import React, { Component } from "react";
import styled from "styled-components";
import Text from "./Text";
import { portalColors } from "./BusinessPortalComponents";

export const TextArea = styled.textarea`
    font-family: Manrope, Helvetica, sans-serif;
    color: ${portalColors.text};
    background: ${portalColors.surfaceSoft};
    font-size: ${p => p.size || "14px"};
    width: -webkit-fill-available;
    height: 111px;
    box-shadow: 0px 3px 6px #00000029;
    border: ${p => p.border || `1px solid ${portalColors.borderStrong}`};
    padding: 10px 20px;
    border-radius: 26px;
    ::placeholder {
        color: ${p => p.placeholderColor || portalColors.textSoft};
        text-align: ${p => p.placeholderAlignment };
        font-size ${ p => p.size };
    }
    font-weight: ${p => p.weight || "500"};
    &:focus {
        outline: none;
        border: 1px solid ${portalColors.text};
        box-shadow: 0 0 0 4px ${portalColors.blueSoft};
    }
`;

export const ErrorTextArea = styled(Text)`
    color: red;
    text-align: left;
    font-size: 12px;
    margin: ${p => p.margin || "0 20px 5px"};
    height: 12px;
    white-space: nowrap;
`;

class FormText extends Component {
    render() {
        const { placeholder, align, errors, onChange, type, onFocus, ...styleProps } = this.props;
        const errorsArray = errors ? errors : [];
    
        return (
            <div>
                <TextArea
                    placeholder={placeholder}
                    placeholderColor="#51315D"
                    align={align}
                    opacity="1.0"
                    type={type}
                    isHighlighted={errorsArray.length > 0}
                    onChange={onChange}
                    onFocus={onFocus}
                    {...styleProps}
                />
                <ErrorTextArea>
                    {errorsArray}
                </ErrorTextArea>
            </div>
        );
    }
}

export default FormText;
